import React from 'react';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { hydrate, unmountComponentAtNode } from 'react-dom';
import { CookiesProvider } from 'react-cookie';
import { Provider } from 'react-redux';
import Loadable from 'react-loadable';
import { setupFeatureFramework } from '@surfline/web-common/dist/features/splitio';
import { identitySelector } from '@surfline/web-common/dist/features/redux';
import { hot } from 'react-hot-loader';
import '@surfline/quiver-themes/stylesheets/normalize.css';

import configureStore from '../stores';
import config from '../config';
import rootReducer from '../reducers';

import '../styles/base.scss';

const root = document.querySelector('#root');
const preloadedState = window.__DATA__; // eslint-disable-line no-underscore-dangle

const history = createBrowserHistory();

// Create a history of your choosing (we're using a browser history in this case)
const store = configureStore(preloadedState, history);

const mount = () => {
  // eslint-disable-next-line global-require,import/newline-after-import
  const Routes = hot(module)(require('../components/Routes').default);

  Loadable.preloadReady().then(() => {
    hydrate(
      <CookiesProvider>
        <Provider store={store}>
          <ConnectedRouter history={history}>
            <Routes />
          </ConnectedRouter>
        </Provider>
      </CookiesProvider>,
      root
    );
  });
};

setupFeatureFramework(config.appKeys.splitio, identitySelector(store.getState()))
  .then(mount)
  .catch(mount);

if (module.hot) {
  module.hot.accept('../components/Routes', () => {
    unmountComponentAtNode(root);
    mount();
  });
  module.hot.accept('../reducers', () => {
    store.replaceReducer(rootReducer(history));
  });
}
